module.exports = __webpack_public_path__ + "img/xtzdhzc.5370576f.jpg";